import { httpClient } from "./httpClient";

// Get the user's local  time zone from the browser.
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
// Get current month date range
const today = new Date();
const startDate = new Date(
  today.getFullYear(),
  today.getMonth(),
  1,
).toISOString();
const endDate = new Date(
  today.getFullYear(),
  today.getMonth() + 1,
  1,
).toISOString();

export const getInvoices = (params: any) => {
  return httpClient.get("/api/invoices", params);
};

export const getTransfers = (params: any) => {
  return httpClient.get("/api/billing/transfers", params);
};

export const sendTransfer = async (transactionID: string) => {
  return httpClient.patch(`/api/billing/transfers/${transactionID}/send`, {});
};

export const finalizeTransfer = async (transactionID: string) => {
  return httpClient.patch(`/api/billing/transfers/${transactionID}/finalize`);
};

export const downloadInvoice = (transactionID: string) => {
  // using getImage here since the response type is blob for pdf as well as img
  return httpClient.getImage(`/api/invoices/${transactionID}/download`);
};

export const downloadTransferInvoice = (transactionID: string) => {
  // using getImage here since the response type is blob for pdf as well as img
  return httpClient.getImage(
    `/api/billing/transfers/${transactionID}/invoice/download`,
  );
};

export const recalculateTransfers = (transactionID: string) => {
  // using getImage here since the response type is blob for pdf as well as img
  return httpClient.patch(
    `/api/billing/transfers/${transactionID}/recalculate-transfer`,
  );
};

export const exportTransfer = (transactionID: string, params?: any) => {
  return httpClient.get(
    `/api/billing/transfers/${transactionID}/export`,
    params,
  );
};

export const cpoTransfer = (id, params) => {
  return httpClient.get(`/api/cpoTransferReport/${id}`, params);
};

export const siteTransfer = (id, params) => {
  return httpClient.get(`/api/siteTransferReport/${id}`, params);
};

export const cpoTransferHeader = (id, params) => {
  return httpClient.get(`/api/cpoTransferReportHeader/${id}`, params);
};

export const siteTransferHeader = (id, params) => {
  return httpClient.get(`/api/siteTransferReportHeader/${id}`, params);
};

export const transferAccount = (params: any) => {
  return httpClient.get(`/api/billing/account-transfers`, params);
};

//new
export const downloadTransactionReceipt = (paymentID: string) => {
  // using getImage here since the response type is blob for pdf as well as img
  return httpClient.getImage(
    `/api/paymentReceipt/${paymentID}?TimeZone=${timeZone}`,
  );
};

export const downloadTransferReceiptInvoice = (
  transferID: string,
  type: "invoice" | "receipt",
) => {
  return httpClient.getImage(
    // using getImage here since the response type is blob for pdf as well as img
    `/api/cpoTransferPDF/${transferID}?Limit=50&WithUser=true&Page=1&StartDateTime=${startDate}&EndDateTime=${endDate}&ChargingStationID=&CompanyID=&TimeZone=${timeZone}&Type=${type}`,
  );
};

export const downloadSiteOwnerTransferReceiptInvoice = (
  transferID: string,
  type: "invoice" | "receipt",
) => {
  return httpClient.getImage(
    // using getImage here since the response type is blob for pdf as well as img
    `/api/siteTransferPDF/${transferID}?Limit=50&WithUser=true&TimeZone=${timeZone}&Type=${type}`,
  );
};

export const getBillingInError = (params: any) => {
  return httpClient.get("/api/billing/in-errors", params);
};

export const getBillingInErrorWithSessionID = (id: string, params: any) => {
  return httpClient.get(`/api/billing/in-error/${id}`, params);
};

export const resolveBillingError = (id: string, params: any) => {
  return httpClient.put(`/api/billing-errors/resolve/${id}`, params);
};

export const retryBillingError = (id: string, params: any) => {
  return httpClient.post(`/api/billing-errors/retry/pending/${id}`, params);
};

export const reprocessTransactions = (
  siteId: string,
) => {
  return httpClient.post(
    `/api/billing/site-transactions/${siteId}/update`,
  );
};
